var _path, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrafficSignSpeedLimitEndNar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "traffic_x5F_sign_x5F_speed_x5F_limit_x5F_end_x5F_nar_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "96px",
    height: "96px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "traffic_x5F_sign_x5F_speed_x5F_limit_x5F_end_x5F_nar"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M14,90V6c0-2.209,1.791-4,4-4h60c2.209,0,4,1.791,4,4v84c0,2.209-1.791,4-4,4H18 C15.791,94,14,92.209,14,90z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78,6v84H18V6H78 M78,4H18c-1.105,0-2,0.895-2,2v84c0,1.105,0.895,2,2,2h60c1.105,0,2-0.895,2-2V6C80,4.895,79.105,4,78,4 L78,4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.085,14h6.465v1.68h-4.62v2.835h4.26v1.56h-4.26v3.12h4.62v1.485h-6.465V14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.245,14h1.815l4.305,7.26V14h1.77v10.68h-1.83L45,17.42v7.26h-1.755V14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.265,14h3.779c0.82,0,1.508,0.085,2.062,0.255c0.556,0.17,1,0.458,1.335,0.862s0.572,0.948,0.713,1.627 c0.14,0.68,0.21,1.53,0.21,2.55c0,1-0.067,1.842-0.202,2.527c-0.136,0.685-0.368,1.24-0.698,1.665s-0.774,0.73-1.335,0.915 c-0.56,0.185-1.265,0.277-2.114,0.277h-3.75V14z M55.109,15.68v7.515h1.935c0.49,0,0.891-0.045,1.2-0.135 c0.31-0.09,0.553-0.275,0.728-0.555c0.175-0.28,0.295-0.678,0.36-1.193c0.064-0.515,0.098-1.192,0.098-2.032 c0-0.75-0.033-1.357-0.098-1.823c-0.065-0.465-0.186-0.83-0.36-1.095s-0.418-0.445-0.728-0.54s-0.71-0.143-1.2-0.143H55.109z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34.452,73.5h1.476v7.355h3.624v1.188h-5.1V73.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.572,73.5h1.476v8.544h-1.476V73.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.561,82.044l0.384-8.544h1.704l2.196,5.916l2.16-5.916h1.669l0.432,8.544h-1.429l-0.287-5.796l-2.1,5.796h-0.984 l-2.148-5.832l-0.24,5.832H43.561z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.616,73.5h1.477v8.544h-1.477V73.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.148,73.5h6.312v1.344h-2.412v7.2h-1.476v-7.2h-2.424V73.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrafficSignSpeedLimitEndNar);
export default __webpack_public_path__ + "static/media/icon-traffic_sign_speed_limit_end_nar.c7ef920e4e0183dbc843ecef024fb6e1.svg";
export { ForwardRef as ReactComponent };